import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLeadLost = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 50 50",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-25 -25)",
		fillRule: "nonzero",
		stroke: "#7a7370",
		strokeWidth: 6.25,
		fill: "none",
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 50,
			cy: 50,
			r: 21.875
		}), /* @__PURE__ */ _jsx("path", { d: "M33.333 33.333L67.35 67.35M66.667 33.333L33.333 66.667" })]
	})
});
export default SvgLeadLost;
